import CombatTablet from './CombatTablet';

export default CombatTablet;
export { CombatTablet };
